"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from "react";
export function useMediaQuery(query) {
  const $ = _c(4);
  let t0;
  if ($[0] !== query) {
    t0 = callback => {
      const matchMedia = window.matchMedia(query);
      matchMedia.addEventListener("change", callback);
      return () => {
        matchMedia.removeEventListener("change", callback);
      };
    };
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subscribe = t0;
  let t1;
  if ($[2] !== query) {
    t1 = () => window.matchMedia(query).matches;
    $[2] = query;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getSnapshot = t1;
  const getServerSnapshot = _temp;
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
function _temp() {
  return false;
}